<template>
    <div class="nxp-mobile-navbar">
        <p>{{ currentStep + 1 }} de {{ steps.length }} etapas</p>
        <div class="nxp-step-group">
            <div v-for="(step, index) in steps" :key="`step-${index}`" class="nxp-step-indicator"
                :class="currentStep == step.order ? 'active' : step.completed ? 'filled' : currentStep >= step.order ? 'dashed' : ''"
                :style="{ background: color, outlineColor: color }"></div>
        </div>

        <button v-if="currentStep > 0" class="nxp-mobile-back-btn" @click="handleBackward">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <mask id="mask0_857_10485" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16"
                    height="16">
                    <rect width="16" height="16" fill="#696969" />
                </mask>
                <g mask="url(#mask0_857_10485)">
                    <path
                        d="M9.33362 11.7688L5.56445 7.99964L9.33362 4.23047L10.0361 4.93297L6.96945 7.99964L10.0361 11.0663L9.33362 11.7688Z"
                        fill="#A9A9A9" />
                </g>
            </svg>
            {{ getPreviousStepTitle }}
        </button>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'mobile-navbar',
    computed: {
        ...mapState('step', ['steps', 'currentStep']),
        ...mapState('company', ['company']),

        stepTitle() {
            return this.steps.filter(item => item.order == this.currentStep)[0].title
        },

        getPreviousStepTitle() {
            return this.steps.filter(item => item.order == this.currentStep - 1)[0].title
        },

        color() {
            return this.company.base_hexcolor || '#1551b1'
        },
    },
    methods: {
        async handleBackward() {
            await this.$store.dispatch("step/decrementCurrentStep");

            const { path } = this.$store.getters["step/current"];

            const { params } = this.$router.history.current;

            this.$router.push({
                name: path,
                params,
            });
        },
        handleJump() {
            const resumeStep = this.$store.getters['step/getResumeStep'];

            this.$store.dispatch('step/updateCurrentStep', {
                order: resumeStep.order,
                shouldTriggerBasicFormSubmit: true,
            });

            this.$router.push({
                name: resumeStep.path
            })
        },
        allowJump() {
            return !this.onEditMode() &&
                this.$store.getters['step/allowJump'] &&
                this.$store.getters['step/current'].path !== 'step-revision'
        },
        onEditMode() {
            const currentPath = this.$router.history.current.name;
            return (currentPath.slice(0, 4) == 'edit')
        },
    },
    created: async function () {
      if (this.onEditMode()) {
            const routeNameToOrderMap = {
                'edit-basic-info': 0,
                'edit-address': 1,
                'edit-diversity': 2,
                'edit-formation': 3,
                'edit-experiences': 4,
                'edit-languages': 5,
                'edit-skills': 6,
                'edit-referral-program': 7,
                'edit-complementary-questions': 8,
            }
            const currentRouteName = this.$router.history.current.name;
            if (routeNameToOrderMap.hasOwnProperty(currentRouteName)) {
              await this.$store.dispatch(
                  'step/updateCurrentStep',
                  { order: routeNameToOrderMap[currentRouteName] }
              )
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.nxp-mobile-navbar {
    display: flex;
    padding: 24px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 8px;
}

.nxp-step-group {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
}

.nxp-mobile-navbar p {
    color: #4F4F4F;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.nxp-step-indicator {
    background-color: #309E3A;
    height: 4px;
    width: 100%;
    min-width: 30px;
    border-radius: 2px;
    opacity: 0.18;
    border: none;
    outline-style: none;
    outline-width: 0px;
    outline-color: #309E3A;
}


.nxp-step-indicator.dashed {
    opacity: 0.6;
    outline-style: dashed;
    outline-width: 2px;
    outline-color: #309E3A;
    outline-offset: 1px;
}

.nxp-step-indicator.filled {
    opacity: 0.7;
}

.nxp-step-indicator.active {
    opacity: 1;
    height: 6px;
}

.nxp-mobile-back-btn {
    cursor: pointer;
    display: flex;
    height: 40px;
    align-items: center;
    gap: 4px;
    background-color: #FFF;
    border: none;

    color: #696969;

    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
</style>